import React, { useEffect, useState } from 'react';
import { CheckCircle, X } from 'lucide-react';
const NAMES = ['María', 'Carlos', 'Laura', 'Roberto', 'Silvina', 'Diego', 'Ana', 'Martín', 'Gabriela', 'Fernando'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Tucumán', 'Santa Fe', 'San Juan'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerNotification();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const triggerNotification = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setNotification({
      name: randomName,
      city: randomCity
    });
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next notification (randomly between 8-15 seconds)
      const nextDelay = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000);
      setTimeout(triggerNotification, nextDelay);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 right-4 z-50 max-w-sm w-full animate-slide-in-right" data-id="element-241">
      <div className="bg-white rounded-lg shadow-xl border-l-4 border-green-500 p-4 flex items-start gap-3 relative" data-id="element-242">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-243">
          <X size={14} data-id="element-244" />
        </button>

        <div className="flex-shrink-0" data-id="element-245">
          <CheckCircle className="h-6 w-6 text-green-500" data-id="element-246" />
        </div>
        <div data-id="element-247">
          <p className="text-sm font-medium text-gray-900" data-id="element-248">
            ¡Nueva compra realizada!
          </p>
          <p className="text-sm text-gray-600 mt-1" data-id="element-249">
            <span className="font-semibold" data-id="element-250">{notification.name}</span> de{' '}
            {notification.city} acaba de comprar este libro digital.
          </p>
          <p className="text-xs text-gray-400 mt-2" data-id="element-251">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}